import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const BrandNewTemplate = styled.div`
  .empty-brand {
    ${mixin.flex({
      direction: 'column',
      justify: 'center',
      align: 'center',
    })}
    margin-top: 116px;

    .empty-text {
      text-align: center;
      line-height: 130%;
      font-size: 16px;
      color: #000;
      font-weight: 500;
    }

    .btn-main {
      min-width: 170px;
      margin-top: 20px;
      border-color: #000;

      .text {
        min-width: unset;
      }

      svg {
        width: 5px;
      }
    }
  }

  .contents-wrap {
    section.box {
      margin-top: 40px;
      position: relative;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        padding-bottom: 40px;
        border-bottom: 8px solid #f9f9f9;
      }

      .section-title {
        padding: 0 16px 16px;

        .main-title-wrapper {
          -webkit-line-clamp: 1;
        }
      }
    }

    .product-item:not(:has(.prdc-title .title)) {
      .detail {
        -webkit-line-clamp: 2 !important;
        word-break: keep-all !important;
      }

      &.type-list .detail {
        padding-right: 22px;
      }
    }

    .infinite-scroll-component {
      overflow: visible !important;
    }
  }

  .corner-brand-main {
    position: relative;
    background-color: #2e2e2e;

    &:only-child {
      padding-bottom: 0 !important;
    }

    .banner-visual-area {
      position: relative;
    }

    .cont-thumbnail {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 0;

      .img {
        width: 100%;
        height: 100%;
      }
    }

    .cont-box {
      position: relative;
      z-index: 1;
      padding: 140px 0 24px 0;
      background-color: rgba(0, 0, 0, 0.25);
    }

    .name-box {
      position: relative;
      padding: 0 16px;
      ${mixin.flex({
        direction: 'column',
        justify: 'flex-end',
        align: 'flex-start',
      })}
      gap: 2px;

      .tag {
        padding: 4px 5px;
        line-height: 100%;
        font-size: 11px;
        font-weight: 400;
        color: #fff;
        background-color: #000;
      }

      .name-ko {
        display: block;
        line-height: 130%;
        font-size: 30px;
        font-weight: 600;
        color: #fff;
        word-break: keep-all;
        overflow-wrap: anywhere;
      }

      .name-en {
        display: block;
        line-height: 130%;
        font-size: 15px;
        font-weight: 400;
        color: #fff;
        word-break: keep-all;
        overflow-wrap: anywhere;
      }
    }

    .btn-like {
      position: absolute;
      width: 36px;
      height: 36px;
      top: 16px;
      right: 16px;
      border-radius: 100px;
      border: 1px solid #e2e2e2;

      .like-pick {
        width: 100%;
        height: 100%;

        svg {
          transform: translateY(1px);
        }

        svg path {
          stroke: #fff;
        }

        &.active {
          > div {
            transform: translateY(1px);
          }

          svg path {
            stroke: transparent;
          }
        }
      }
    }

    .brand-desc-wrap {
      margin-top: 16px;
      padding: 0 16px;
      ${mixin.flex({
        direction: 'column',
        justify: 'flex-start',
        align: 'flex-start',
      })}

      .brand-desc {
        .text {
          line-height: 130%;
          text-align: left;
          font-size: 13px;
          font-weight: 400;
          color: #fff;
          word-break: keep-all;
          overflow-wrap: anywhere;

          &.is-open {
            display: block;
          }
        }
      }

      .btn-more-less {
        display: inline-block;
        margin-top: 2px;
        font-size: 13px;
        font-weight: 400;
        line-height: 130%;
        color: #fff;
        text-decoration: underline;
      }
    }

    .type-banner-scroll-wrap:has(.item) {
      margin-top: 20px;

      .item:only-child {
        min-width: 100%;
      }
    }

    .area-brand-activity-tag {
      background-color: #000;
      width: 100%;
      height: 38px;
      pointer-events: none;

      .brand-activity-tag {
        background-color: transparent;
        color: #fff;

        .text em {
          font-weight: 600;
        }

        svg + span {
          margin-left: 4px;
        }

        svg path {
          fill: #fff;
        }

        &.type-heart svg path {
          stroke: #fff;
        }
      }

      .items-swiper {
        width: 100%;
        height: 100%;

        .swiper {
          width: 100%;
          height: 100%;
        }

        .swiper-slide {
          ${mixin.flex({})}
        }
      }
    }

    .banner-visual-area:not(:has(.cont-thumbnail)) {
      .cont-box {
        padding: 76px 0 24px 0;
        background-color: transparent;
      }
    }
  }

  .corner-shortcut {
    .shortcut-list {
      padding: 0 16px;
      ${mixin.flex({
        wrap: 'wrap',
        justify: 'flex-start',
        align: 'flex-start',
      })};
      gap: 12px;
    }
  }

  .corner-coupon {
    .coupon-list {
      padding: 0 16px;
      ${mixin.flex({
        wrap: 'wrap',
        justify: 'flex-start',
        align: 'flex-start',
      })};
      gap: 8px;
    }

    .btn-coupon-all-down {
      width: 186px;
      margin-top: 24px;
    }
  }

  .corner-best-prd {
    .rank {
      left: 16px;
    }
  }

  .corner-styleclip {
    .item {
      border-radius: 0;

      .area-video .veVideo .xgplayer,
      .area-video .img {
        padding-bottom: 162.4203%;
      }

      .area-prd {
        border: 1px solid #eee;
        border-top: 0 !important;
      }
    }
  }

  .input-box {
    padding: 12px 16px 4px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    .empty-brand {
      margin-top: ${mixin.pxToVw('116')};

      .empty-text {
        font-size: ${mixin.pxToVw('16')};
      }

      .btn-main {
        min-width: ${mixin.pxToVw('170')};
        margin-top: ${mixin.pxToVw('20')};

        svg {
          width: ${mixin.pxToVw('5')};
        }
      }
    }

    .contents-wrap {
      section.box {
        margin-top: ${mixin.pxToVw('40')};

        &:last-child {
          padding-bottom: ${mixin.pxToVw('40')};
          border-bottom: ${mixin.pxToVw('8')} solid #f9f9f9;
        }

        .section-title {
          padding: ${mixin.pxToVw('0 16 16')};
        }
      }

      .product-item:not(:has(.prdc-title .title)) {
        &.type-list .detail {
          padding-right: ${mixin.pxToVw('22')};
        }
      }
    }

    .corner-brand-main {
      margin-bottom: ${mixin.pxToVw('-20')};

      .cont-box {
        padding: ${mixin.pxToVw('140 0 24 0')};
      }

      .name-box {
        padding: ${mixin.pxToVw('0 16')};
        gap: ${mixin.pxToVw('2')};

        .tag {
          padding: ${mixin.pxToVw('4 5')};
          font-size: ${mixin.pxToVw('11')};
        }

        .name-ko {
          font-size: ${mixin.pxToVw('30')};
        }

        .name-en {
          font-size: ${mixin.pxToVw('15')};
        }
      }

      .btn-like {
        width: ${mixin.pxToVw('36')};
        height: ${mixin.pxToVw('36')};
        top: ${mixin.pxToVw('16')};
        right: ${mixin.pxToVw('16')};
        border-radius: ${mixin.pxToVw('100')};
      }

      .brand-desc-wrap {
        margin-top: ${mixin.pxToVw('16')};
        padding: ${mixin.pxToVw('0 16')};

        .brand-desc {
          .text {
            font-size: ${mixin.pxToVw('13')};
          }
        }

        .btn-more-less {
          margin-top: ${mixin.pxToVw('2')};
          font-size: ${mixin.pxToVw('13')};
        }
      }

      .type-banner-scroll-wrap:has(.item) {
        margin-top: ${mixin.pxToVw('20')};
      }

      .area-brand-activity-tag {
        height: ${mixin.pxToVw('38')};

        .brand-activity-tag {
          svg + span {
            margin-left: ${mixin.pxToVw('4')};
          }
        }
      }

      .banner-visual-area:not(:has(.cont-thumbnail)) {
        .cont-box {
          padding: ${mixin.pxToVw('76 0 24 0')};
        }
      }
    }

    .corner-shortcut {
      .shortcut-list {
        padding: ${mixin.pxToVw('0 16')};
        gap: ${mixin.pxToVw('12')};
      }
    }

    .corner-coupon {
      .coupon-list {
        padding: ${mixin.pxToVw('0 16')};
        gap: ${mixin.pxToVw('8')};
      }

      .btn-coupon-all-down {
        width: ${mixin.pxToVw('186')};
        margin-top: ${mixin.pxToVw('24')};
      }
    }

    .corner-best-prd {
      .rank {
        left: ${mixin.pxToVw('16')};
      }
    }

    .filter-listbar {
      .area-left {
        min-width: ${mixin.pxToVw('54')};
        padding: ${mixin.pxToVw('12 6 12 16')};
      }

      .list {
        padding: ${mixin.pxToVw('2 16')};
      }
    }

    .input-box {
      padding: ${mixin.pxToVw('12 16 4')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .empty-brand {
      margin-top: 96px;

      .empty-text {
        font-size: 26px;
      }

      .btn-main {
        min-width: 180px;
        margin-top: 30px;

        .text {
          font-size: 15px;
        }

        .icon-arrow {
          margin-left: 5px;

          svg {
            width: 13px;
          }
        }
      }
    }

    .contents-wrap {
      padding-top: 20px;

      section.box {
        max-width: 1326px;
        margin: 80px auto 0;

        &.ly-full {
          max-width: none;
          overflow-x: hidden;

          .section-title {
            max-width: 1326px;
            margin: 0 auto;
          }
        }

        &:last-child {
          margin-bottom: 0;
          padding-bottom: 80px;
          border-bottom: none;
        }

        .section-title {
          padding: 0px 0px 20px;
        }
      }
    }

    .corner-brand-main {
      .banner-visual-area {
        .banner-visual-inner {
          position: relative;
          z-index: 1;
          max-width: 1326px;
          margin: 0 auto;
          width: 100%;
          height: 100%;
          padding: 70px 0 40px 0;
          ${mixin.flex({
            justify: 'flex-start',
            align: 'flex-start',
          })}
          gap: 63px;
        }
      }

      .cont-thumbnail {
        position: relative;
        top: auto;
        left: auto;
        width: 505px;
        height: 318px;
        z-index: 1;
        flex-shrink: 0;
        order: 1;
      }

      .cont-thumbnail-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 0;
        filter: blur(75px);

        .img {
          width: 100%;
          height: 100%;

          &::after {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.3);
          }
        }
      }

      .cont-box {
        width: 759px;
        padding: 0;
        background-color: transparent;
      }

      .name-box {
        padding: 0;
        width: 720px;
        ${mixin.flex({
          wrap: 'wrap',
          justify: 'flex-start',
          align: 'flex-start',
        })}

        .tag {
          order: 1;
          flex-shrink: 0;
          align-self: center;
          font-size: 13px;
          margin-left: 8px;
        }

        .name-ko {
          order: 0;
          font-size: 40px;
        }

        .name-en {
          font-size: 18px;
          font-weight: 600;
          flex-basis: 100%;
          order: 2;
        }
      }

      .btn-like {
        width: 40px;
        height: 40px;
        top: 18px;
        right: 0;

        .like-pick {
          svg path {
            fill: #fff;
            stroke: transparent;
          }

          &.active {
            svg path {
              fill: rgb(255, 70, 0);
            }
          }
        }
      }

      .brand-desc-wrap {
        margin-top: 24px;
        padding: 0;
        width: 740px;

        .brand-desc {
          .text {
            font-size: 17px;
          }
        }

        .btn-more-less {
          margin-top: 4px;
          font-size: 17px;
        }
      }

      .type-banner-scroll-wrap:has(.item) {
        margin-top: 46px;

        .swiper-slide:only-child {
          width: 470px !important;
        }
      }

      .area-brand-activity-tag {
        background-color: rgba(21, 21, 21, 0.5);
        height: 50px;

        .activity-tag-inner {
          max-width: 1326px;
          margin: 0 auto;
          width: 100%;
          height: 100%;
          ${mixin.flex({
            justify: 'flex-start',
            align: 'center',
          })}
          gap: 64px;
        }

        .brand-activity-tag {
          position: relative;
          padding: 0;
          font-size: 16px;

          svg {
            width: 20px;
            height: 20px;
          }

          &:nth-child(n + 2)::before {
            content: '';
            display: block;
            position: absolute;
            top: 50%;
            left: -32px;
            width: 1px;
            height: 16px;
            background-color: rgba(255, 255, 255, 0.5);
            transform: translateY(-50%);
          }
        }
      }

      .banner-visual-area:not(:has(.cont-thumbnail)) {
        .cont-box {
          padding: 0;
          width: 100%;

          .brand-desc-wrap,
          .name-box {
            width: 100%;
          }

          .type-banner-scroll-wrap:has(.item) {
            width: 759px;
          }
        }

        .btn-like {
          top: -30px;
        }
      }
    }

    .corner-shortcut {
      .shortcut-inner {
        background-color: #f9f9f9;
        padding: 40px;
      }

      .shortcut-list {
        padding: 0;
        gap: 10px;
        width: 826px;
        margin: 0 auto;

        &:has(.btn:only-child) {
          justify-content: center;
          align-items: center;
        }
      }
    }

    .corner-coupon {
      .coupon-inner {
        background-color: #f9f9f9;
        padding: 40px;
      }

      .coupon-list {
        padding: 0;
        gap: 10px;
        width: 826px;
        margin: 0 auto;

        &:has(.item:only-child) {
          justify-content: center;
          align-items: center;
        }
      }

      .btn-coupon-all-down {
        width: 440px;
        margin-top: 32px;
      }
    }

    .corner-best-prd {
      .rank {
        left: 0;
      }
    }

    .corner-rank-prd {
      .item:nth-child(1) {
        .img:after {
          content: '';
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.03);
        }

        .area-info {
          .detail {
            margin-top: 15px !important;
            color: #e2e2e2 !important;
          }
        }
      }
    }

    .corner-styleclip {
      .item {
        .area-video .veVideo .xgplayer,
        .area-video .img {
          padding-bottom: 133.3333%;
        }

        .area-prd {
          border: 1px solid #e7e7e7;
        }
      }
    }

    .filter-listbar {
      .area-left {
        padding: 0px 10px 0px 0px;
        min-width: auto;
      }

      .list {
        padding: 0;
      }
    }

    .bottom-product-wrap {
      max-width: 1326px;
      padding-top: 27.5px;
      margin: 0 auto;

      .area-menu {
        margin-bottom: 7.5px;
        padding-bottom: 20px;
        border-bottom: 1px solid #eee !important;

        .category-menubar {
          .swiper {
            padding: 0;
          }

          &.cm-type4 {
            margin-top: 16px;

            .swiper {
              padding: 0 20px;
            }

            .swiper-slide {
              margin-right: 28px;
            }

            & + .cm-type4 {
              border-top: none;
            }

            & ~ .category-menubar.cm-type4 {
              margin-top: 0;

              .menubar-swiper {
                background-color: #f6f6f6;
              }
            }
          }
        }
      }

      .inner-area-menu .category-menubar:first-child {
        border-bottom: none;
      }

      .filter-listbar {
        top: 0;
      }

      .wrap-pagination {
        margin-top: 72px;
      }
    }
  }
`;
